import { useState } from "preact/hooks";
import { ToggleWidgetProps } from "../types";

export function ToggleWidget(props: ToggleWidgetProps) {
  const { value, incrementQty, decrementQty } = props;
  const [checked, setChecked] = useState<boolean>(false);

  const toggleHandler = (event: any) => {
    const handler = checked ? decrementQty : incrementQty;
    setChecked(!checked);
    return handler();
  };
  // dispatch increment/decrement for option
  return (
    <div className="kits__table-row-item toggle-widget widget">
      <label className="toggle">
        <input
          className="toggle-checkbox"
          type="checkbox"
          checked={checked}
          onChange={toggleHandler}
        />
        <div className="toggle-switch"></div>
      </label>
    </div>
  );
}
